// extracted by mini-css-extract-plugin
module.exports = {"lineButton":"LineLoginButton_lineButton__YO5rQ","lineIcon":"LineLoginButton_lineIcon__9e0m_"};